/* eslint-disable max-len */
import * as Sentry from '@sentry/browser';
import {BrowserTracing} from '@sentry/tracing';

/*
	If the error message is specific you can add it to the ignoreErrors array. Be careful because it matches error value and type, so adding TypeError will
	ignore all type errors.
	To add an error to specific errors copy its value, type and the first object in the stacktrace array.
*/

const ignoreErrors = [
	'ResizeObserver loop limit exceeded',
	new RegExp('Failed to update a ServiceWorker for scope .+ with script .+'),
	'Unterminated string in JSON at position 15713',
	'ServiceWorker script at https://billing.httpool.com/service-worker.js for scope https://billing.httpool.com/ encountered an error during installation.',
	'Couldn\'t find your IP',
	'Failed to execute \'send\' on \'WebSocket\': Still in CONNECTING state.',
	'ResizeObserver loop completed with undelivered notifications.',
	'newestWorker is null',
	'Script https://billing.httpool.com/service-worker.js load failed',
	'ChunkLoadError',
	'Couldn\'t find your IP',
	'Response not successful: Received status code 496',
	'Response not successful: Received status code 401',
	'TypeError: Failed to fetch',
	// TODO: Remove when deploying final version to production
	'Cannot read properties of undefined (reading \'length\')',
	// See: https://alephrnd.atlassian.net/browse/MBS-2097
	'React ErrorBoundary Error: Failed to execute \'insertBefore\' on \'Node\': The node before which the new node is to be inserted is not a child of this nod',
];

const APP_ENVIRONMENT = import.meta.env.REACT_APP_ENVIRONMENT;

if (APP_ENVIRONMENT !== 'dev' && APP_ENVIRONMENT !== 'qa') {
	Sentry.init({
		dsn:              'https://fbabf796f0b643f1b4c0ec31ea167219@o1128294.ingest.us.sentry.io/6335909',
		release:          import.meta.env.REACT_APP_RELEASE,
		integrations:     [new BrowserTracing()],
		tracesSampleRate: 0.5,
		sampleRate:       1,
		environment:      import.meta.env.REACT_APP_ENVIRONMENT,
		ignoreErrors,
		denyUrls:         [new RegExp('inspectlet.js')],
	}
	);
}
